import React, { useState } from 'react';

import {
	Form,
	Label,
	Input,
	Title,
	TextArea,
	FormGroup,
	FormWrapper,
	SubmitButton,
	MessageBanner,
	HiddenHoneypot,
} from './ContactForm.styled';
import { Neon } from '../Neon';

// Helper function to encode form data for POST request
const encode = data => {
	return Object.keys(data)
		.map(
			key =>
				encodeURIComponent(key) + '=' + encodeURIComponent(data[key]),
		)
		.join('&');
};

export default function ContactForm() {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [submitted, setSubmitted] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState(false);

	const handleChange = e => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = e => {
		e.preventDefault();
		setSubmitting(true);
		setError(false);

		fetch('/', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: encode({ 'form-name': 'contact', ...formData }),
		})
			.then(() => {
				setSubmitting(false);
				setSubmitted(true);
			})
			.catch(err => {
				console.error('Form submission error:', err);
				setSubmitting(false);
				setError(true);
			});
	};

	if (submitted) {
		return (
			<FormWrapper>
				<MessageBanner>
					<h3>Thanks for reaching out! 🎸</h3>
					<p>
						Your message has been sent successfully. I'll get back
						to you soon.
					</p>
				</MessageBanner>
			</FormWrapper>
		);
	}

	return (
		<div>
			<Title>
				<Neon as="h1" color="green">
					Contact
				</Neon>
			</Title>
			<FormWrapper className="card">
				<Form
					name="contact"
					method="POST"
					data-netlify="true"
					data-netlify-honeypot="bot-field"
					onSubmit={handleSubmit}
				>
					<input type="hidden" name="form-name" value="contact" />

					<HiddenHoneypot>
						<label>
							Don’t fill this out if you're human:{' '}
							<input name="bot-field" onChange={handleChange} />
						</label>
					</HiddenHoneypot>

					<FormGroup>
						<Label htmlFor="name">Name</Label>
						<Input
							type="text"
							id="name"
							name="name"
							required
							value={formData.name}
							onChange={handleChange}
							placeholder="Your Name"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="email">Email</Label>
						<Input
							type="email"
							id="email"
							name="email"
							required
							value={formData.email}
							onChange={handleChange}
							placeholder="your.email@example.com"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="message">Message</Label>
						<TextArea
							id="message"
							name="message"
							required
							value={formData.message}
							onChange={handleChange}
							placeholder="What's on your mind?"
						/>
					</FormGroup>

					<SubmitButton type="submit" disabled={submitting}>
						{submitting ? 'Sending...' : 'Send Message'}
					</SubmitButton>

					{error && (
						<MessageBanner $error>
							<p>
								Something went wrong submitting your message.
								Please try again!
							</p>
						</MessageBanner>
					)}
				</Form>
			</FormWrapper>
		</div>
	);
}
